// src/components/About.jsx
import { Container, Row, Col, Image } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import aboutImage from '../assets/b1.png'; // ← replace with your image

const About = () => (
  <section className="py-5" style={{ backgroundColor: '#000', color: '#fff' }}>
    <Container>
      <h2 id='about' className="text-center mb-4 display-5">Sobre Nós</h2>
      <Row className="align-items-center">
        {/* Text */}
        <Col md={6}>
          <p className="lead">
            Há anos no mercado, nossa barbearia se consolidou como referência em estilo, cuidado e excelência. Contamos com uma equipe de profissionais altamente qualificados, que aliam técnica apurada e atenção aos detalhes para oferecer serviços personalizados a cada cliente.

Oferecemos o melhor em cortes de cabelo — do clássico ao moderno — além de barbearia tradicional, aparos de barba com design sofisticado e tratamentos de pigmentação para realçar o visual. Também cuidamos do seu olhar com design de sobrancelhas, moldando-as de acordo com seu formato de rosto e personalidade.
          </p>
          <p>
           Aqui, você encontra muito mais do que um simples corte: oferecemos uma experiência completa, em ambiente acolhedor e equipado com o que há de mais moderno em estética masculina. Agende seu horário e descubra o verdadeiro padrão de qualidade que só quem tem anos de tradição pode oferecer.
          </p>
        </Col>

        {/* Optional Image */}
        <Col md={6} className="text-center mt-4 mt-md-0">
          <Image 
            src={aboutImage} 
            alt="Barbershop Interior" 
            fluid 
            rounded 
            style={{ maxHeight: '350px', objectFit: 'cover' }}
          />
        </Col>
      </Row>
    </Container>
  </section>
);

export default About;
